import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { AppMode, DocumentMetadataService } from './document-metadata.service';

/**
 * Routes declare a bare section name (`title: 'Library'`); the metadata entry supplies the
 * base, so every navigation recomposes the whole title instead of appending to what is there.
 */
@Injectable({ providedIn: 'root' })
export class DocumentTitleStrategy extends TitleStrategy {
  private readonly metadata = inject(DocumentMetadataService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.metadata.setRoute(routeMode(snapshot.root), this.buildTitle(snapshot) ?? null);
  }
}

/** Route data describes the route */
interface AppModeRouteData {
  readonly appMode?: AppMode;
}

function routeMode(route: ActivatedRouteSnapshot): AppMode | null {
  for (let node: ActivatedRouteSnapshot | null = route; node; node = node.firstChild) {
    const { appMode } = node.data as AppModeRouteData;
    if (appMode) return appMode;
  }
  return null;
}
